import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
    isDarkMode: false,
}

const themeSlice = createSlice({
    name: 'theme',
    initialState,
    reducers: {
        setIsDarkMode: (state, action: PayloadAction<boolean>) => {
            state.isDarkMode = action.payload;
        },
    }
});

export const { setIsDarkMode } = themeSlice.actions;
export default themeSlice.reducer; 